"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DialogTitle", {
    enumerable: true,
    get: function() {
        return DialogTitle;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useDialogTitle = require("./useDialogTitle");
const _renderDialogTitle = require("./renderDialogTitle");
const _useDialogTitleStylesstyles = require("./useDialogTitleStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const DialogTitle = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useDialogTitle.useDialogTitle_unstable)(props, ref);
    (0, _useDialogTitleStylesstyles.useDialogTitleStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useDialogTitleStyles_unstable')(state);
    return (0, _renderDialogTitle.renderDialogTitle_unstable)(state);
});
DialogTitle.displayName = 'DialogTitle';
